import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconFacebookStyle0 = gravityIconIndividualCss;

const GravityIconFacebook = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: 'e74b3d2f126bcdfea9a3e81042eace28bb160eb0', color: this.color, size: this.size }, h("svg", { key: '856cc41d7c3fe3781666041be0ca02b934b1d70d', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: '988e3f7b4c0e81e791a8acc6a2ca119710edda9d', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M20 11a9 9 0 1 0-10.406 8.89v-6.288H7.309V11h2.285V9.017c0-2.255 1.343-3.501 3.4-3.501.984 0 2.014.175 2.014.175v2.215h-1.135c-1.118 0-1.467.694-1.467 1.406V11h2.496l-.399 2.602h-2.097v6.289A9.002 9.002 0 0 0 20 11Z", fill: "currentColor" }))));
    }
};
GravityIconFacebook.style = GravityIconFacebookStyle0;

export { GravityIconFacebook as gravity_icon_facebook };

//# sourceMappingURL=gravity-icon-facebook.entry.js.map